<template>
  <Modal v-if="showModalChooseDelivery" @close="$emit('closeModal')">
    <Loading v-if="loading" />
    <div class="chooseDelivery">
      <div class="chooseDelivery__header">
        <span class="title">{{ $t('chooseDelivery') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="CloseModal"
          @click="$emit('closeModal')"
        />
      </div>
      <div class="chooseDelivery__body">
        <Table
          v-if="data.length"
          :data="data"
          :columns="columns"
          selected-field="deliveryId"
          @assign-delivery-table="assignDeliveryTable"
        />
        <div v-if="!data.length" class="chooseDelivery__body-noTable">
          <p>{{ $t('noReservations') }}</p>
        </div>
      </div>
      <Button
        variant="redBordered"
        :title="$t('cancel')"
        @click="$emit('closeModal')"
      />
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import { columns } from './configs';
import { DataReservations } from '@/store/modules/pharmacy/types';

@Options({
  name: 'ChooseDelivery',
  props: ['showModalChooseDelivery', 'activeBoxId', 'activeLocker'],
  components: {
    Loading
  },
  data() {
    return {
      data: [],
      reservations: [],
      activeReservations: null,
      columns: columns(this.$t),
      loading: false
    };
  },
  created() {
    this.show();
  },
  computed: {
    ...mapState('pharmacy', ['pharmacy'])
  },
  methods: {
    ...mapActions('pharmacy', [
      'assignDelivery',
      'getPharmacy',
      'getPickupBoxesByPharmacy'
    ]),
    async show() {
      this.loading = true;

      if (this.pharmacy) {
        this.reservations = this.pharmacy?.reservations;

        this.data = [...this.reservations]?.filter(
          (reservation: DataReservations) => reservation.unassigned === true
        );
      }

      this.loading = false;
    },
    async assignDeliveryTable(deliveryId: string) {
      this.loading = true;

      this.activeReservations = this.data.find(
        (i: DataReservations) => i.deliveryId === deliveryId
      );

      const { id } = this.$route.params;

      const payload = {
        assignToBox: true,
        boxInfo: {
          lockerId: [this.activeLocker],
          boxId: this.activeBoxId
        }
      };

      await this.assignDelivery({
        data: payload,
        pharmacyId: id,
        deliveryId: deliveryId
      });

      this.$emit('closeModal');

      await this.getPharmacy(id);
      await this.getPickupBoxesByPharmacy(id);

      this.loading = false;

      this.show();
    }
  }
})
export default class ChooseDelivery extends Vue {}
</script>

<style lang="scss" scoped>
.chooseDelivery {
  width: 460px;
  height: 100vh;
  max-height: 450px;
  padding: 24px;
  .chooseDelivery__header {
    display: flex;
    justify-content: space-between;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .chooseDelivery__body {
    height: 342px;
    padding: 24px 0;
    .text {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
  }
}
</style>
